// extracted by mini-css-extract-plugin
export default {"reportActionEditorModal":"reports_reportActionEditorModal__yp5Wu","paper":"reports_paper__9ySio","formContainer":"reports_formContainer__lO9HV"};